import type { ReactNode } from 'react';

const icons: Record<
  'door' | 'bag' | 'pencil' | 'trash' | 'download' | 'mail' | 'print' | 'pin' | 'badge',
  ReactNode
> = {
  door: (
    <>
      <rect x="5" y="2" width="14" height="20" rx="1" />
      <path d="M8 5h8v14H8z" />
      <circle cx="14" cy="12" r=".7" />
    </>
  ),
  bag: (
    <>
      <path d="M5 8h14l1 13H4L5 8Z" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" />
    </>
  ),
  pencil: (
    <>
      <path d="m3 17 10.5-10.5 4 4L7 21H3v-4Z" />
      <path d="m12 8 4 4M15 5l1-1a2.1 2.1 0 0 1 3 3l-1 1" />
    </>
  ),
  trash: (
    <>
      <path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7" />
      <path d="M10 11v5m4-5v5" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12m-4-4 4 4 4-4" />
      <path d="M4 17v3h16v-3" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </>
  ),
  print: (
    <>
      <path d="M7 8V3h10v5M7 16H4V9h16v7h-3" />
      <path d="M7 13h10v8H7zM17 11h.01" />
    </>
  ),
  pin: (
    <>
      <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  badge: (
    <>
      <path d="M12 2l2.5 1.6 3-.1 1.2 2.8 2.5 1.7-.7 2.9.7 2.9-2.5 1.7-1.2 2.8-3-.1L12 20l-2.5-1.6-3 .1-1.2-2.8-2.5-1.7.7-2.9-.7-2.9 2.5-1.7 1.2-2.8 3 .1L12 2Z" />
      <path d="m8 11 2.5 2.5L16 8" />
    </>
  ),
};

export function CartIcon({
  name,
  className = 'size-4',
}: {
  name: keyof typeof icons;
  className?: string;
}) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {icons[name]}
    </svg>
  );
}
